<template>
  <div id="search">
    <b-container v-if="authenticated">
      <h2>Search by ids</h2>
      <h4>Select an organism and enter an id to get the fasta sequence</h4>
      <b-card no-body class="text-left mb-1">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row>
            <Tree :data="tree_data" :item-events="itemEvents" />
            <b-col>
              <b-card bg-variant="light">
                <b-form-group
                  id="identifierGroup"
                  label-size="sm"
                  label="Identifiers:"
                  label-for="identifierInput"
                  description="The identifiers must correspond to identifiers used in the genome annotation of the organism"
                >
                  <b-form-textarea
                    id="identifierInput"
                    v-model="form.liste"
                    size="sm"
                    required
                    :rows="3"
                    :max-rows="30"
                    placeholder="Enter identifiers (one per line)"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  id="typeInputGroup"
                  label-size="sm"
                  label="Protein or CDS:"
                  label-for="typeInput"
                >
                  <b-form-select
                    id="typeInput"
                    v-model="form.dbtype"
                    size="sm"
                    :options="types"
                    required
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                  id="speciesInputGroup"
                  label-size="sm"
                  label="Selected organism:"
                  label-for="speciesInput"
                >
                  <b-form-input
                    id="speciesInput"
                    v-model="form.species"
                    size="sm"
                    required
                    placeholder="Select an organism in the tree"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <b-button variant="outline-primary" size="sm" @click="setExample">Example</b-button>
                <b-button type="submit" variant="primary">Submit</b-button>
                <b-button type="reset" variant="danger">Reset</b-button>

                <b-alert
                  class="alert"
                  dismissible
                  :show="dismissCountDown"
                  variant="danger"
                  @dismissed="dismissCountDown = 0"
                  @dismiss-count-down="countDownChanged"
                  >{{ errorMessage }}</b-alert
                >
              </b-card>
              <b-button v-if="fasta" class="rawbutton" variant="secondary" size="sm" @click="getRaw"
                >Download result</b-button
              >
              <b-form-textarea
                id="fasta"
                v-model="fasta"
                size="sm"
                placeholder="Here will appear your fasta sequence"
                :rows="10"
                :max-rows="30"
                readonly
              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-container>
    <b-alert v-else show variant="danger">You must be logged to acccess this function</b-alert>
  </div>
</template>

<script>
import Tree from '@/components/Tree.vue';
import Vue from 'vue';

export default {
  name: 'Search',
  components: {
    Tree,
  },
  data() {
    var component = this;
    return {
      fasta: '',
      form: { liste: '', dbtype: 'protein', species: '', idSpecies: '' },
      example: {
        liste:
          'evm_27.model.AmTr_v1.0_scaffold02479.1\nevm_27.model.AmTr_v1.0_scaffold00322.3\nevm_27.model.AmTr_v1.0_scaffold00322.1',
        dbtype: 'protein',
        species: 'Amborella trichopoda',
        idSpecies: 312,
      },
      types: [
        { text: 'Protein', value: 'protein' },
        { text: 'CDS', value: 'CDS' },
        { text: 'transcriptome', value: 'transcriptome' },
      ],
      errorMessage: 'Error',
      dismissSecs: 3,
      dismissCountDown: 0,
      itemEvents: {
        click: function () {
          if (arguments[1].children.length == 0) {
            component.form.species = arguments[1].text;
            component.form.idSpecies = arguments[1].id;
          }
        },
      },
    };
  },

  computed: {
    tree_data: function () {
      return this.$store.getters.getTreeData;
    },
    authenticated: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    onSubmit(event) {
      event.preventDefault();

      let component = this;

      if (this.form.species === '') {
        this.errorMessage = 'Please select an organism in the tree';
        this.showAlert();
      } else {
        Vue.http.post('api/get_sequences', component.form).then(
          (resp) => {
            if (resp.body.success === false) {
              component.errorMessage = resp.body.message;
              component.showAlert();
            } else {
              if (resp.body.message !== '') {
                component.errorMessage = 'Warning ! ' + resp.body.message;
                component.showAlert();
              }

              component.fasta = resp.body.sequences;
            }
          },
          () => {
            component.errorMessage = 'Server error';
            component.showAlert();
          }
        );
      }
    },
    onReset() {
      event.preventDefault();
      this.form.liste = '';
      this.form.dbtype = 'Protein';
      this.form.species = '';
      this.form.idSpecies = '';
      this.fasta = '';
    },
    getRaw() {
      const filename = 'symdbResult.fasta.txt';
      this.downloadTextFile(filename, this.fasta);
    },

    setExample() {
      this.form = Object.assign({}, this.example);
    },
    downloadTextFile(filename, text) {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  },
};
</script>
<style scoped>
#search {
  margin: 25px;
}

button {
  margin: 10px;
}

.rawbutton {
  margin: 0px;
}

.alert {
  max-width: 400px;
}
</style>
